import { Box, Container, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import { getBuildVersion } from '../helpers/base';

const Footer = observer((props: any) => {
  return (
    <Container maxWidth='lg'>
      <Box
        component='footer'
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: props?.auth ? '#ff5f1f' : '#ffffff',
          py: 2,
          mt: '25px',
        }}
      >
        <Typography variant='body2' sx={{ fontWeight: '500' }}>
          © {new Date().getFullYear()} PERSEUS BIOMICS BV - CONFIDENTIAL
        </Typography>
        {props?.auth && (
          <Typography
            variant='body2'
            sx={{ fontWeight: '500', color: '#808080' }}
          >
            {getBuildVersion()}
          </Typography>
        )}
      </Box>
    </Container>
  );
});

export default Footer;
